<template>
  <div class="header-box">
    <div class="header clearfix">
      <div class="fl logo">
        <img @click="goIndex" src="../../assets/images/logo1.png" />
      </div>
      <ul class="menu fl clearfix">
        <li class="item" v-for="item in menuList" :key="item.title"><a :class="{active: item.active}" :href="item.href">{{item.title}}</a></li>
      </ul>
      <div class="fr login">
        <span class="login-sp" @click="Login">登录</span><span class="line">|</span><a @click="becomeDeveloper">成为开发者</a>
        <span class="line">|</span><a target="_blank" href="https://logismg.tongtool.com/index.html">成为物流商</a>
      </div>
      <!-- 用户注册 -->
      <registered :registerModal="registerModal"></registered>
    </div>
  </div>
</template>
<script>
import registered from '../../views/index/components/registered';
export default {
  name: 'header2',
  components: {
    registered
  },
  data () {
    return {
      menuList: [{
        href: './index.html',
        title: '首页',
        active: false
      }, {
        href: './guides.html',
        title: '开发指南',
        active: false
      }, {
        href: './apiDoc.html',
        title: '接口文档',
        active: false
      }, {
        href: './notice.html',
        title: '公告',
        active: false
      }],
      registerModal: false // 成为开发者模态框
    };
  },
  created () {
    let weburl = window.location.href;
    if (weburl) {
      if (weburl.indexOf('index.html') > -1) {
        this.menuList[0].active = true;
      } else if (weburl.indexOf('guides.html') > -1) {
        this.menuList[1].active = true;
      } else if (weburl.indexOf('apiDoc.html') > -1) {
        this.menuList[2].active = true;
      } else if (weburl.indexOf('notice.html') > -1) {
        this.menuList[3].active = true;
      } else {
        this.menuList[0].active = true;
      }
    }
  },
  methods: {
    goIndex () {
      window.location.href = './index.html';
    },
    Login () {
      window.location.href = './openApi.html#/';
    },
    // 成为开发者
    becomeDeveloper () {
      this.registerModal = true;
    }
  }
};
</script>

<style scoped>
  .header-box{background-color: #ffffff;}
.header{width: 1146px;margin: 0 auto;height: 80px;}
.header .logo{margin-top: 20px;}
.header .menu{margin-top: 35px;}
.header .menu .item{margin-left: 112px;float: left}
.header .menu .item a{font-size: 15px;color: #777777;}
.header .menu .item .active{font-size: 15px;color: #333333;font-weight: bold}
.header .login{font-size: 15px;color: #555555;margin-top: 35px;}
.header .login .login-sp{cursor: pointer}
.header .line{padding:  0 10px;}
</style>



// WEBPACK FOOTER //
// src/components/layout/header2.vue